import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../../styles/common-section.css';

const CommonSection = ({ title }) => {
  return (
    <div className="common__section">
      <Container>
        <div className="common__content text-center">
          <div className="common__breadcrumb">
            <Link to="/">Home</Link>
            <span className="separator">/</span>
            <span className="current">{title}</span>
          </div>
          <h1 className="common__title">{title}</h1>
        </div>
      </Container>
    </div>
  );
};

export default CommonSection;